<template>
  <Modal
    :id="'cmp-hide-invoices'"
    @cancelled="onCancelClick"
    :loadingFlag="loadingFlag"
  >
    <template slot="header"
      >{{$t('hide_the_following_invoices')}}</template
    >
    <template slot="body">
      <SearchList
        :id="'users'"
        :items="invoiceProjects"
        :keyProperty="'invoice_project_id'"
        :label="'invoice_project_name'"
        :isSearchable="false"
        @selected="onSelectedProjects"
      />
    </template>
    <template slot="options">
      <button class="dt-button s6" @click="onCancelClick">{{$t('cancel')}}</button>
      <button class="dt-button v1 s6" @click="onOKClicked">{{$t('ok')}}</button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import SearchList from "@dtplugins/search-list/search-list";
import { UserService } from "../../services/user.service";

export default {
  components: {
    SearchList,
    Modal
  },
  props: {},
  data: function() {
    return {
      invoiceProjects: [],
      searchString: "",
      selectedProjects: [],
      loadingFlag: false
    };
  },
  mounted: function() {
    this.loadingFlag = true;
    UserService.findUnhiddenInvoiceProjects({
      user_id: this.user_id
    }).then(res => {
      this.invoiceProjects = res.data.invoice_projects;
      this.loadingFlag = false;
      console.log("Log: this.invoiceProjects", this.invoiceProjects);
    });
  },
  computed: {
    user_id: function() {
      return this.$route.params.user_id;
    }
  },
  methods: {
    onOKClicked: async function() {
      this.loadingFlag = true;
      await UserService.hideInvoiceProjects({
        items: `[${Array.from(this.selectedProjects)
          .map(e => `"${e}"`)
          .join(",")}]`,
        perm_user_id: this.user_id
      });
      const invoiceProjects = await UserService.fetchHiddenInvoiceProjects({
        user_id: this.user_id
      });
      this.loadingFlag = false;

      this.$emit("added", invoiceProjects.data.invoice_projects);
    },
    onCancelClick: function() {
      this.$emit("cancelled", true);
    },
    onUsersSearched: function(searchString) {},
    onSelectedProjects: function(selectedProjects) {
      this.selectedProjects = selectedProjects;
    }
  }
};
</script>

<style lang="scss" scoped></style>
